import {FC, useCallback, useState} from "react";
import {ListItemText} from "../Menu.tsx";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import CropFreeIcon from "@mui/icons-material/CropFree";
import Modal from "./PhotoWithQRCode/Modal.tsx";
import HelpButton from "../../base/HelpButton.tsx";

export type PhotoWithQRCodeButtonProps = {
    profileID: string
    onClick?: () => void
}

const PhotoWithQRCodeButton: FC<PhotoWithQRCodeButtonProps> = ({profileID, onClick}) => {
    const [open, setOpen] = useState<boolean>(false)

    const handleClick = useCallback(() => {
        setOpen(true);
        onClick?.();
    }, [onClick])
    const handleClose = useCallback(() => setOpen(false), [])

    return (
        <>
            <ListItem disablePadding>
                <ListItemButton onClick={handleClick}>
                    <ListItemIcon>
                        <CropFreeIcon/>
                    </ListItemIcon>
                    <ListItemText primary="Foto met QR-code maken"/>
                </ListItemButton>
                <ListItemText primary={
                    <HelpButton help="Met deze functie kunt u een foto selecteren, waar dan automatisch een QR code aan toe wordt gevoegd. Vervolgens kunt u deze opslaan op uw apparaat en waar wenselijk uitprinten."/>
                }/>
            </ListItem>
            <Modal profileID={profileID} open={open} onClose={handleClose}/>
        </>
    )
}

export default PhotoWithQRCodeButton
